import { render, staticRenderFns } from "./PromotionPrint.vue?vue&type=template&id=22b47200&scoped=true"
import script from "./PromotionPrint.vue?vue&type=script&lang=js"
export * from "./PromotionPrint.vue?vue&type=script&lang=js"
import style0 from "./PromotionPrint.vue?vue&type=style&index=0&id=22b47200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b47200",
  null
  
)

export default component.exports